export default {
  install(Vue, { store }) {
    Vue.prototype.$customize = {
      reset: () => { },
      load: async () => {
        let settingRes = await window.NxVetV2.getCustomizeData("setting");
        store.dispatch("customize/actionSetCustomize", settingRes.result);
        if (settingRes.result.kind) {
          let kindBreed = (await window.NxVetV2.getCustomizeData("kind")).result
            .data;
          kindBreed.forEach((kind) => {
            kind.breed.sort((row1, row2) => {
              return row1.name.localeCompare(row2.name);
            });
          });

          store.dispatch("customize/actionSetCustomizeKindBreed", kindBreed);
          let clone = JSON.parse(JSON.stringify(kindBreed));
          clone.forEach((kind) => {
            delete kind.breed;
          });
          clone.sort((c1, c2) => {
            return c1.name.localeCompare(c2.name);
          });
          store.dispatch("customize/actionSetCustomizeKind", clone);
        }

        if (settingRes.result.service) {
          let services = (await window.NxVetV2.getCustomizeData("service"))
            .result.data;
          store.dispatch("customize/actionSetCustomizeService", services);
        } else {
          let services = require(`../../../backend/Data/enum/serviceData.json`);
          store.dispatch("customize/actionSetCustomizeService", services);
        }

        if (settingRes.result.label) {
          let label = (await window.NxVetV2.getCustomizeData("label")).result
            .data;

          store.dispatch("customize/actionSetCustomizeLabel", label);
          let clone = JSON.parse(JSON.stringify(label));
          clone.forEach((group) => {
            delete group.label;
          });
          store.dispatch("customize/actionSetCustomizeLabelGroup", clone);
        }

        if (settingRes.result.disease) {
          let disease = (await window.NxVetV2.getCustomizeData("disease"))
            .result.data;

          store.dispatch("customize/actionSetCustomizeDisease", disease);
          let clone = JSON.parse(JSON.stringify(disease));
          clone.forEach((group) => {
            delete group.disease;
          });
          store.dispatch("customize/actionSetCustomizeDiseaseGroup", clone);
        }

        if (settingRes.result.reminder) {
          let reminder = (await window.NxVetV2.getCustomizeData("reminder"))
            .result.data;

          store.dispatch("customize/actionSetCustomizeReminder", reminder);
        } else {
          console.log("reminder");

          await window.NxVetV2.addDefaultReminder("reminder");

          let reminder = (await window.NxVetV2.getCustomizeData("reminder"))
            .result.data;

          store.dispatch("customize/actionSetCustomizeReminder", reminder);
        }

        const getStaffListRes = await window.NxVetV2.getStaffList();        
        store.dispatch("customize/actionSetCustomizeStaffList", getStaffListRes.result);
        
      },
    };
  },
};
